import React from "react";
import { View, Dimensions, LayoutChangeEvent } from "react-native";
import { EStyleSheet, useDynamicStyles } from "react-native-extended-stylesheet-typescript";
import { useServices } from "../../contexts/ServiceContext";
import { ApplicationController } from "../../controllers/ApplicationController";
import { GlobalStyles } from "../style/Style";

const TWINSPIRES_THEME = {
    $FP_BASE_COLOUR: "#042a51",
    $FP_ACCENT_COLOUR: "#0066cc",
    $FP_BACKGROUND_COLOUR: "#ffffff",
    $FP_DEFAULT_ICON_FILL: "#ffffff",
    $FP_ACTIVE_ICON_FILL: "#ffffff",
    $FP_DEFAULT_NAVIGATION_BUTTON_BACKGROUND: "#042a51",
    $FP_DEFAULT_SHADOW: "#0a1128",

    $FP_NAVIGATION_TEXT: "#0a1128",
    $FP_NAVIGATION_BACKGROUND: "#042a51",
    $FP_NAVIGATION_ICON_FILL: "#e7f3fe",
    $FP_NAVIGATION_ICON_FILL_ACTIVE: "#0066cc",
    $FP_NAVIGATION_BUTTON_TEXT: "#e7f3fe",

    $FP_LEADERBOARD_PLACE_BACKGROUND: "#e7f3fe",
    $FP_LEADERBOARD_PLACE_TEXT: "#042a51",
    $FP_LEADERBOARD_MY_PLACE_BACKGROUND: "#e7f3fe",
    $FP_LEADERBOARD_MY_PLACE_TEXT: "#0066cc",
    $FP_LEADERBOARD_SCORE_TEXT: "#35ce2b",

    $FP_SPLASH_BACKGROUND: "#042a51",
    $FP_SPLASH_LOGO: "#ffffff",

    $FP_TIME_DESCRIPTOR: "#042a51",
    $FP_TIME_DESCRIPTOR_TEXT: "#ffffff",
    $FP_TIME_BACKGROUND: "#edeef6",
    $FP_TIME_TEXT: "#042a51",
    $FP_TIME_BORDER_RADIUS: 8,

    $FP_GAME_CTA_TEXT: "#ffffff",
    $FP_GAME_TITLE_TEXT: "#ffffff",
    $FP_GAME_DATE_TEXT: "#dee1f5",
    $FP_EDGE_GAME_TITLE_TEXT: "#ffffff",
    $FP_EDGE_GAME_SUBTITLE_TEXT: "#ffffff",
    $FP_EDGE_GAME_TEXT: "#ffffff",

    $FP_CHECKBOX_BACKGROUND: "#edeef6",
    $FP_CHECKBOX_BORDER: "#042a51",
    $FP_CHECKBOX_CHECKED: "#35ce2b",

    $FP_THANKS_TEXT: "#0a1128",
    $FP_SUBMITTED_CHECKMARK: "#35ce2b",

    $FP_SUBMITTED_CTA_BACKGROUND: "#042a51",

    $FP_BET_DISPLAY_BACKGROUND: "#0a1128",
    $FP_BET_DISPLAY_HEADER: "#ffffff",
    $FP_BET_DISPLAY_AMOUNT: "#35ce2b",
    $FP_BET_DISPLAY_CTA_BACKGROUND: "#042a51",

    $FP_CASH_BACKGROUND: "#35ce2b",
    $FP_CASH_TEXT: "#ffffff",
    $FP_CASH_SEPARATOR: "#015ab3",

    $FP_PROP_HEADER: "#042a51",
    $FP_PROP_HEADER_TEXT: "#ffffff",
    $FP_PROP_HEADER_DATE: "#dde0f4",
    $FP_PROP_BACKGROUND: "#edeef6",
    $FP_PROP_PICKEM_TEXT: "#ffffff",
    $FP_PROP_SELECTED_BACKGROUND: "#e7f3fe",
    $FP_PROP_SELECTED: "#0066cc",
    $FP_PROP_ICON: "#042a51",
    $FP_PROP_SELECTED_ICON: "#ffffff",
    $FP_PROP_TEXT: "#042a51",
    $FP_PROP_TEAM_TEXT: "#FFFFFF",
    $FP_PROP_SELECTED_TEXT: "#042a51",
    $FP_PROP_AT_TEXT: "#042a51",
    $FP_AT_BOX_BORDER: "#042a51",
    $FP_AT_BOX_BACKGROUND: "#edeef6",
    $FP_GAME_CTA_BACKGROUND_COLOUR: "#edeef6",

    $FP_WINNING_PROP: "#35ce2b",
    $FP_WINNING_PROP_TEXT: "#0b5606",
    $FP_LOSING_PROP: "#ce2b42",
    $FP_LOSING_PROP_TEXT: "#59080a",
    $FP_PICKED_BACKGROUND: "#0066cc",
    $FP_PICKED_TEXT: "#ffffff",

    $FP_DISABLED_BUTTON: "#d9dae2",
    $FP_DISABLED_TEXT: "#b6bac6",

    $FP_TROPHY: "#f7c001",
    $FP_WIN_TEXT: "#35ce2b",
    $FP_LOSS_TEXT: "#ce2b42",

    $FP_BASE_BUTTON_BACKGROUND: "#dde0f4",
    $FP_BASE_BUTTON_TEXT: "#042a51",
    $FP_ACCENT_BUTTON_TEXT: "#ffffff",
    $FP_ACCENT_BUTTON_COLOUR: "#0066cc",
    $FP_CTA_BUTTON_TEXT: "#ffffff",
    $FP_CTA_BUTTON_COLOUR: "#35ce2b",

    $FP_BORDER_RADIUS: "15px",
    $FP_PROP_BORDER_RADIUS: "30px",
    $FP_BORDER_THICKNESS: "2px",
    $FP_BUTTON_RADIUS: "60px",
    $FP_DROPDOWN_BACKGROUND: "#0a1128",
    $FP_DROPDOWN_OPTIONS_BACKGROUND: "#042a51",
    $FP_DROPDOWN_BORDER_RADIUS: 8,
    $FP_DROPDOWN_TEXT: "#ffffff",
    $FP_BORDER_COLOR: "#edeef6",

    $FP_HR_PLACE_BACKGROUND: "#042a51",
    $FP_HR_PLACE_BACKGROUND_ACTIVE: "#0066cc",
    $FP_HR_PLACE_TEXT: "#ffffff",
    $FP_HR_PLACE_CARD_BORDER_RADIUS: "8px",
    $FP_HR_PLACEMENT_TEXT: "#042a51",
    $FP_HR_PLACEMENT_BACKGROUND: "#e7f3fe",
    $FP_HR_PLACEMENT_BORDER: "#042a51",

    $FP_HR_HORSE_ONE_BACKGROUND: "#ce2b42",
    $FP_HR_HORSE_ONE_TEXT: "#ffffff",
    $FP_HR_HORSE_TWO_BACKGROUND: "#ffffff",
    $FP_HR_HORSE_TWO_TEXT: "#042a51",
    $FP_HR_HORSE_THREE_BACKGROUND: "#0066cc",
    $FP_HR_HORSE_THREE_TEXT: "#ffffff",
    $FP_HR_HORSE_FOUR_BACKGROUND: "#f7c001",
    $FP_HR_HORSE_FOUR_TEXT: "#042a51",
    $FP_HR_HORSE_FIVE_BACKGROUND: "#27a71f",
    $FP_HR_HORSE_FIVE_TEXT: "#ffffff",
    $FP_HR_HORSE_SIX_BACKGROUND: "#042a51",
    $FP_HR_HORSE_SIX_TEXT: "#f7c001",
    $FP_HR_HORSE_SEVEN_BACKGROUND: "#fd7689",
    $FP_HR_HORSE_SEVEN_TEXT: "#042a51",
    $FP_HR_HORSE_EIGHT_BACKGROUND: "#fa669a",
    $FP_HR_HORSE_EIGHT_TEXT: "#042a51",
    $FP_HR_HORSE_NINE_BACKGROUND: "#5da5ec",
    $FP_HR_HORSE_NINE_TEXT: "#042a51",
    $FP_HR_HORSE_TEN_BACKGROUND: "#8200cc",
    $FP_HR_HORSE_TEN_TEXT: "#ffffff",
    $FP_HR_HORSE_ELEVEN_BACKGROUND: "#f3e7d1",
    $FP_HR_HORSE_ELEVEN_TEXT: "#f64382",
    $FP_HR_HORSE_TWELVE_BACKGROUND: "#70e568",
    $FP_HR_HORSE_TWELVE_TEXT: "#042a51",
    $FP_HR_HORSE_THIRTEEN_BACKGROUND: "#695123",
    $FP_HR_HORSE_THIRTEEN_TEXT: "#ffffff",
    $FP_HR_HORSE_FOURTEEN_BACKGROUND: "#693323",
    $FP_HR_HORSE_FOURTEEN_TEXT: "#f7c001",
    $FP_HR_HORSE_FIFTEEN_BACKGROUND: "#d2bf9d",
    $FP_HR_HORSE_FIFTEEN_TEXT: "#042a51",
    $FP_HR_HORSE_SIXTEEN_BACKGROUND: "#00ccc0",
    $FP_HR_HORSE_SIXTEEN_TEXT: "#f64382",
    $FP_HR_HORSE_SEVENTEEN_BACKGROUND: "#042a51",
    $FP_HR_HORSE_SEVENTEEN_TEXT: "#ffffff",
    $FP_HR_HORSE_EIGHTEEN_BACKGROUND: "#1a6815",
    $FP_HR_HORSE_EIGHTEEN_TEXT: "#f7c001",
    $FP_HR_HORSE_NINETEEN_BACKGROUND: "#042a51",
    $FP_HR_HORSE_NINETEEN_TEXT: "#f64382",
    $FP_HR_HORSE_TWENTY_BACKGROUND: "#e02c6b",
    $FP_HR_HORSE_TWENTY_TEXT: "#f7c001",
    $FP_HR_HORSE_TWENTY_ONE_BACKGROUND: "#cd74ff",
    $FP_HR_HORSE_TWENTY_ONE_TEXT: "#042a51",
};

const NEW_THEME = {
    $FP_BASE_COLOUR: "#000000",
    $FP_ACCENT_COLOUR: "#00549c",
    $FP_BACKGROUND_COLOUR: "#ffffff",
    $FP_DEFAULT_ICON_FILL: "#000000",
    $FP_ACTIVE_ICON_FILL: "#ffffff",
    $FP_DEFAULT_NAVIGATION_BUTTON_BACKGROUND: "#e3e3e3",
    $FP_ACCENT_BUTTON_COLOUR: "#00549c",

    $FP_NAVIGATION_TEXT: "#000000",
    $FP_NAVIGATION_BACKGROUND: "#00549c",
    $FP_NAVIGATION_ICON_FILL: "#ffffff",
    $FP_NAVIGATION_BUTTON_TEXT: "#ffffff",

    $FP_LEADERBOARD_PLACE_BACKGROUND: "#e3e3e3",
    $FP_LEADERBOARD_PLACE_TEXT: "#000000",
    $FP_LEADERBOARD_MY_PLACE_BACKGROUND: "#00549c",
    $FP_LEADERBOARD_MY_PLACE_TEXT: "#ffffff",
    $FP_LEADERBOARD_SCORE_TEXT: "#4dd14f",

    $FP_SPLASH_BACKGROUND: "#00549c",
    $FP_SPLASH_LOGO: "#ffffff",

    $FP_TIME_DESCRIPTOR: "#edeef6",
    $FP_TIME_DESCRIPTOR_TEXT: "#ffffff",
    $FP_TIME_BACKGROUND: "#e3e3e3",
    $FP_TIME_TEXT: "#000000",

    $FP_GAME_CTA_TEXT: "#ffffff",
    $FP_GAME_TITLE_TEXT: "#ffffff",
    $FP_GAME_DATE_TEXT: "#8f8f8f",
    $FP_EDGE_GAME_TITLE_TEXT: "#ffffff",
    $FP_EDGE_GAME_SUBTITLE_TEXT: "#ffffff",
    $FP_EDGE_GAME_TEXT: "#ffffff",

    $FP_CHECKBOX_BACKGROUND: "#e3e3e3",

    $FP_CASH_BACKGROUND: "#4dd14f",
    $FP_CASH_TEXT: "#ffffff",
    $FP_CASH_SEPARATOR: "#2563eb",

    $FP_PROP_BACKGROUND: "#e3e3e3",
    $FP_PROP_SELECTED: "#2563eb",
    $FP_PROP_TEXT: "#000000",
    $FP_PROP_SELECTED_TEXT: "#ffffff",
    $FP_PROP_AT_TEXT: "#ffffff",
    $FP_WINNING_PROP: "#4dd14f",
    $FP_WINNING_PROP_TEXT: "#0e4610",
    $FP_LOSING_PROP: "#ff5151",
    $FP_LOSING_PROP_TEXT: "#500d0d",
    $FP_PICKED_BACKGROUND: "#2563eb",
    $FP_PICKED_TEXT: "#ffffff",

    $FP_DISABLED_BUTTON: "#ededed",
    $FP_DISABLED_TEXT: "#bbbbbb",

    $FP_TROPHY: "#eac142",
    $FP_WIN_TEXT: "#4dd14f",
    $FP_LOSS_TEXT: "#ff5151",

    $FP_BASE_BUTTON_BACKGROUND: "#e3e3e3",
    $FP_BASE_BUTTON_TEXT: "#000000",
    $FP_ACCENT_BUTTON_TEXT: "#ffffff",

    $FP_BORDER_RADIUS: "0px",
    $FP_PROP_BORDER_RADIUS: "0px",
    $FP_BORDER_THICKNESS: "1px",
    $FP_BUTTON_RADIUS: "0px",
    $FP_DROPDOWN_BORDER: "rgba(0, 0, 0, 0.1)",
    $FP_DROPDOWN_TEXT: "#000000",
    $FP_BORDER_COLOR: "#e3e3e3",

    $FP_HR_PLACE_BACKGROUND: "#000000",
    $FP_HR_PLACE_BACKGROUND_ACTIVE: "#00549c",
    $FP_HR_PLACE_TEXT: "#ffffff",
    $FP_HR_PLACE_CARD_BORDER_RADIUS: "0px",

    $FP_HR_HORSE_ONE_BACKGROUND: "#ce2b42",
    $FP_HR_HORSE_ONE_TEXT: "#ffffff",
    $FP_HR_HORSE_TWO_BACKGROUND: "#ffffff",
    $FP_HR_HORSE_TWO_TEXT: "#042a51",
    $FP_HR_HORSE_THREE_BACKGROUND: "#0066cc",
    $FP_HR_HORSE_THREE_TEXT: "#ffffff",
    $FP_HR_HORSE_FOUR_BACKGROUND: "#f7c001",
    $FP_HR_HORSE_FOUR_TEXT: "#042a51",
    $FP_HR_HORSE_FIVE_BACKGROUND: "#27a71f",
    $FP_HR_HORSE_FIVE_TEXT: "#ffffff",
    $FP_HR_HORSE_SIX_BACKGROUND: "#042a51",
    $FP_HR_HORSE_SIX_TEXT: "#f7c001",
    $FP_HR_HORSE_SEVEN_BACKGROUND: "#fb5970",
    $FP_HR_HORSE_SEVEN_TEXT: "#042a51",
    $FP_HR_HORSE_EIGHT_BACKGROUND: "#f64382",
    $FP_HR_HORSE_EIGHT_TEXT: "#042a51",
    $FP_HR_HORSE_NINE_BACKGROUND: "#00bbcc",
    $FP_HR_HORSE_NINE_TEXT: "#042a51",
    $FP_HR_HORSE_TEN_BACKGROUND: "#8200cc",
    $FP_HR_HORSE_TEN_TEXT: "#ffffff",
    $FP_HR_HORSE_ELEVEN_BACKGROUND: "#f3e7d1",
    $FP_HR_HORSE_ELEVEN_TEXT: "#f64382",
    $FP_HR_HORSE_TWELVE_BACKGROUND: "#35ce2b",
    $FP_HR_HORSE_TWELVE_TEXT: "#042a51",
    $FP_HR_HORSE_THIRTEEN_BACKGROUND: "#695123",
    $FP_HR_HORSE_THIRTEEN_TEXT: "#ffffff",
    $FP_HR_HORSE_FOURTEEN_BACKGROUND: "#693323",
    $FP_HR_HORSE_FOURTEEN_TEXT: "#f7c001",
    $FP_HR_HORSE_FIFTEEN_BACKGROUND: "#d2bf9d",
    $FP_HR_HORSE_FIFTEEN_TEXT: "#042a51",
    $FP_HR_HORSE_SIXTEEN_BACKGROUND: "#00ccc0",
    $FP_HR_HORSE_SIXTEEN_TEXT: "#f64382",
    $FP_HR_HORSE_SEVENTEEN_BACKGROUND: "#042a51",
    $FP_HR_HORSE_SEVENTEEN_TEXT: "#ffffff",
    $FP_HR_HORSE_EIGHTEEN_BACKGROUND: "#1a6815",
    $FP_HR_HORSE_EIGHTEEN_TEXT: "#f7c001",
    $FP_HR_HORSE_NINETEEN_BACKGROUND: "#042a51",
    $FP_HR_HORSE_NINETEEN_TEXT: "#f64382",
    $FP_HR_HORSE_TWENTY_BACKGROUND: "#e02c6b",
    $FP_HR_HORSE_TWENTY_TEXT: "#f7c001",
    $FP_HR_HORSE_TWENTY_ONE_BACKGROUND: "#cd74ff",
    $FP_HR_HORSE_TWENTY_ONE_TEXT: "#042a51",
};

const buildGlobals = (alternateTheme: boolean) => {
    const entireScreenWidth = Dimensions.get("window").width;
    const entireScreenHeight = Dimensions.get("window").height;
    const theme = alternateTheme ? NEW_THEME : TWINSPIRES_THEME;
    return {
        $rem: Math.max(entireScreenWidth / 380, 1),
        $screenHeight: entireScreenHeight,
        $FP_HEADER_FONT: "Bebas Neue, Helvetica, Arial, sans-serif",
        $FP_BASE_FONT: "Open Sans, Helvetica, Arial, sans-serif",
        ...theme,
    };
};

EStyleSheet.build(buildGlobals(false));

type MainContainerProps = {
    children?: React.ReactNode;
};

export const MainContainer = ({ children }: MainContainerProps): JSX.Element => {
    const styles = useDynamicStyles(calculateStyles);
    const { edgeDeploy, alternateTheme } = useServices();
    const handleLayout = (event: LayoutChangeEvent) => EStyleSheet.build(buildGlobals(alternateTheme));
    const containerStyle = edgeDeploy ? styles.edgeContainer : styles.container;
    return (
        <View onLayout={handleLayout} style={styles.outer}>
            <View style={containerStyle}>
                <ApplicationController />
            </View>
        </View>
    );
};

const calculateStyles = () => {
    return EStyleSheet.create({
        outer: {
            flex: 1,
        },
        container: {
            zIndex: 1,
            width: "100%",
            height: 660,
            borderColor: () => EStyleSheet.value(GlobalStyles.BASE_COLOUR),
            borderWidth: () => EStyleSheet.value(GlobalStyles.BORDER_THICKNESS),
            borderRadius: () => EStyleSheet.value(GlobalStyles.BORDER_RADIUS),
            overflow: "hidden",
            alignSelf: "center",
            color: () => EStyleSheet.value(GlobalStyles.BASE_COLOUR),
            backgroundColor: () => EStyleSheet.value(GlobalStyles.BACKGROUND_COLOUR),
        },
        edgeContainer: {
            zIndex: 1,
            width: "100%",
            maxWidth: 1290,
            minHeight: 500,
            alignSelf: "center",
            overflow: "hidden",
            color: () => EStyleSheet.value(GlobalStyles.BASE_COLOUR),
        },
    });
};
